import React, { useEffect, useState } from "react";
import { Grid, Box, AppBar, Tab, Tabs } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Header from "../Header/Header";
import { getStyles } from "./styles";
import Upload from "../Common/Upload";
import fileService from '../../services/FileService';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: any) {
  return {
    id: `creatio-imports-tab-${index}`,
    "aria-controls": `creatio-imports-tabpanel-${index}`,
  };
}

export default function CreatioImports() {
  const [value, setValue] = React.useState(0);
  const [messageSettings, setMessageSettings] = useState({
    open: false,
    message: "",
    severity: "info" as 'error' | 'info' | 'success' | 'warning',
  });
  const theme = useTheme();
  const styles = getStyles(theme);

  const handleChangeTabs = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const showMessage = (msg: string, severity: 'error' | 'info' | 'success' | 'warning') => {
    setMessageSettings({ open: true, message: msg, severity });
  };

  const closeMessage = () => {
    setMessageSettings({
      open: false,
      message: "",
      severity: messageSettings.severity,
    });
  };

  const handleUpload = async (file: File, uploader: (file: File) => Promise<any>) => {   
    const response = await uploader(file); 
    
    if(response.isErr()) {
      let message = '';
      messageSettings.severity = 'error';
      if(response.error.result.isJust()) {
        message = ` ${response.error.result.value.message}`;
      } else {
        message = ` ${response.error.message}`;
      }

      return { 
        success: false, 
        errorMessage: `Oops, something went wrong. Error: ${message}` 
      };
    }

    return { success: true };
  }
  
  const uploadCreatioFile = (file: File) => handleUpload(file, fileService.uploadCreatioZipFile);

  return (
    <>
      <Header />
      <Box sx={styles.root}>
        <Grid container >
          <Box sx={{
            width: 1
          }}>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChangeTabs}
                aria-label="creatioImportsTabs"
                textColor="inherit"
                indicatorColor='secondary'
              >
                <Tab label="Creatio File" {...tabProps(0)} />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <Upload
                fileType={'zip'}
                onUpload={uploadCreatioFile}
              />
            </TabPanel>
          </Box>
        </Grid>
      </Box>
    </>
  );
}
